import { useState, useEffect } from "react";
import useAuth from "../context/AuthProvider";
import { StateLoginsList } from "../components/Lists/StateLoginsList";
import { apiClient } from "../helper/api";

export const StateLogins = () => {
    const [stateLogins, setStateLogins] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState('');
    const [selectedLicensee, setSelectedLicensee] = useState('');
    const [selectedState, setSelectedState] = useState('');
    const { user } = useAuth();
    const token = user?.token;

    const fetchData = async () => {
        try {
            const res = await apiClient('/StateLogins/getAllStateLogins', {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }),
                body: JSON.stringify({
                    partner: selectedPartner.toString(),
                    licensee: selectedLicensee.toString(),
                    state: selectedState.toString()
                })
            });

            if (res?.data) {
                setStateLogins(res.data);
            } else {
                setStateLogins([]);
            }
        } catch (error) {
            console.error('Error fetching state logins:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [selectedPartner, selectedLicensee, selectedState]);

    return (
        <StateLoginsList 
            data={stateLogins} 
            fetchData={fetchData} 
            selectedPartner={selectedPartner} 
            setSelectedPartner={setSelectedPartner}  
            selectedLicensee={selectedLicensee} 
            setSelectedLicensee={setSelectedLicensee}  
            selectedState={selectedState}  
            setSelectedState={setSelectedState}
        />
    );
};